import { useContext } from 'react';
import StampCardContext from '../context/stampCardContext';

/**
 * useAuthContext is a convenience hook to access the auth context
 */
export default function useStampCardContext() {
  return useContext(StampCardContext);
}
